import InfiniteScroll from 'react-infinite-scroll-component';
import { Role } from 'auth';
import { createSearchParams, useNavigate, useSearchParams } from 'react-router-dom';
import { SignUpPagesWrapper } from '@/modules/auth/components/SignUpPagesWrapper.tsx';
import { withPrivateAccess } from '@/modules/auth/hocs/withPrivateAccess.tsx';
import { APPLY_REGISTER_ID } from '@/modules/common/constants/search-params.ts';
import { entityPaths } from '@/modules/entity/routes.tsx';
import { useRegisterListQuery } from '@/modules/investor-dashboard/queries/registers.tsx';
import { Spinner } from 'ui';

const SelectRegisterPage = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  const {
    data: registerList,
    fetchNextPage,
    hasNextPage,
  } = useRegisterListQuery({ page: 1, page_size: 30 });

  const handleSelectRegister = (apply_register_id: number) => {
    navigate(
      {
        pathname: entityPaths.static.abnLookupEntity,
        search: createSearchParams({
          ...Object.fromEntries(params.entries()),
          [APPLY_REGISTER_ID]: String(apply_register_id),
        }).toString(),
      },
      {
        replace: false,
      },
    );
  };

  return (
    <SignUpPagesWrapper>
      <div className="w-full flex items-center h-full justify-center">
        <div className="max-w-[660px] w-full px-3 sm:px-6  flex flex-col items-start justify-center space-y-10">
          <p className="sm:text-[48px] sm:leading-[56px] text-[38px] leading-[46px] font-semibold font-[RecifeDisplay]">
            Select register
          </p>
          <InfiniteScroll
            next={fetchNextPage}
            dataLength={registerList?.pages.length ?? 0}
            hasMore={hasNextPage || false}
            loader={
              <div className="flex justify-center items-center h-16 w-full">
                <Spinner size="md" variant="primary" />
              </div>
            }
            className="w-full"
          >
            <div className="w-full flex flex-col items-start space-y-4">
              {registerList?.pages.map(({ data }) =>
                data.map(({ name, id }) => (
                  <div
                    key={'registerItem_' + id}
                    className="w-full flex items-center justify-start rounded-xl border border-gray-200 p-4 cursor-pointer"
                    onClick={() => handleSelectRegister(id)}
                  >
                    <p className="text-[14px] leading-[22px] capitalize">{name}</p>
                  </div>
                )),
              )}
            </div>
          </InfiniteScroll>
        </div>
      </div>
    </SignUpPagesWrapper>
  );
};

export default withPrivateAccess(SelectRegisterPage, Role.SR_INVESTOR);
